import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { RootRoutes } from "./pages/app-routes/root.route";
import { BrowserRouter } from "react-router-dom";
import { LoadingProvider, useLoading } from "./shared/contexts/loading.context";
import { LoadingComponent } from "./shared/components/loading/loading.component";

const queryClient = new QueryClient();

const theme = createTheme({
  typography: {
    fontFamily:
      '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
});

const AppContent = () => {
  const { isLoading, loadingMessage } = useLoading();

  return (
    <>
      {isLoading && <LoadingComponent message={loadingMessage} />}
      <RootRoutes />
    </>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LoadingProvider>
            <AppContent />
          </LoadingProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
